import { Platform } from '@angular/cdk/platform';
import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../icon';

@Component({
  selector: 'sc-itinerary-alt',
  template: `
    <div class="container">
      <div class="head">
        <h1
          mat-dialog-title
          id="itinerary-alt-title-id"
          class="sc-design-text-1"
        >
          {{ 'MapAppBottomSheet.howToGetIn' | translate }}
        </h1>
        <button type="button" class="close-dialog-btn" (click)="onClose()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : { dialogTitle: 'MapAppBottomSheet.howToGetIn' | translate }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>

      <div class="app-list">
        <section class="link-section">
          <button class="app-link" type="button" (click)="launchGoogleMap()">
            <sc-icon name="google_map"></sc-icon>
            <span class="sc-design-text-3-bold">{{
              'MapApps.googleMapLink' | translate
            }}</span>
          </button>
        </section>
        <section class="link-section">
          <button class="app-link" type="button" (click)="launchWaze()">
            <sc-icon name="waze"></sc-icon>
            <span class="sc-design-text-3-bold">{{
              'MapApps.wazeMapLink' | translate
            }}</span>
          </button>
        </section>
        <section class="link-section">
          <button class="app-link" type="button" (click)="launchAppleMap()">
            <sc-icon name="apple_map"></sc-icon>
            <span class="sc-design-text-3-bold">{{
              'MapApps.appleMapLink' | translate
            }}</span>
          </button>
        </section>
      </div>
    </div>
  `,
  styleUrls: ['./itinerary-alt.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IconComponent, TranslateModule],
})
export class ItineraryAltComponent {
  @Output() closeEvent = new EventEmitter<void>();
  @Output() clickGMaps = new EventEmitter<void>();
  @Output() clickWaze = new EventEmitter<void>();
  @Output() clickAppleMaps = new EventEmitter<void>();

  constructor(public platform: Platform) {}

  launchGoogleMap() {
    this.clickGMaps.emit();
  }

  launchWaze() {
    this.clickWaze.emit();
  }

  launchAppleMap() {
    this.clickAppleMaps.emit();
  }

  onClose() {
    this.closeEvent.emit();
  }
}
